<template>
  <section class="alarm-code-list-panel">
    <div class="alarm-code-toolbar">
      <div class="seg-tabs">
        <button v-for="f in stateFilters" :key="f.value" type="button" class="seg-tab"
          :class="{ active: stateFilter === f.value }" :disabled="loading" @click="onStateChange(f.value)">
          {{ f.label }}
        </button>
      </div>
    </div>
    <AlarmRecordTable :records="records" show-station pagination server-pagination :server-total="total"
      :page="page" :page-size="pageSize" :loading="loading" @update:page="onPageChange" />
  </section>
</template>

<script setup>
import AlarmRecordTable from './AlarmRecordTable.vue'

const props = defineProps({
  alarmCode: { type: String, default: '' },
  timeRange: { type: String, default: '' },
  records: { type: Array, default: () => [] },
  total: { type: Number, default: 0 },
  page: { type: Number, default: 1 },
  pageSize: { type: Number, default: 10 },
  stateFilter: { type: String, default: 'all' },
  loading: { type: Boolean, default: false },
})
const emit = defineEmits(['change'])

// 状态过滤走后端接口（枚举与接口一致）；下钻接口不支持 keyword，故不提供关键词搜索
const stateFilters = [
  { label: '全部', value: 'all' },
  { label: '未恢复', value: 'UNRECOVERED' },
  { label: '已恢复', value: 'RECOVERED' },
  { label: '自动恢复', value: 'AUTO_RECOVERED' },
]

// 切换状态回到第 1 页；翻页保持当前状态。统一交给父组件重新请求
function onStateChange(value) {
  emit('change', { page: 1, state: value })
}
function onPageChange(nextPage) {
  emit('change', { page: nextPage, state: props.stateFilter })
}
</script>

<style scoped lang="scss">
.alarm-code-list-panel {
  min-height: 100%;
  padding: 20px 24px;
  box-sizing: border-box;
  // background: #f7f8fa;
  font-family: 'PingFang SC', 'HarmonyOS Sans SC', sans-serif;
}

.alarm-code-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 16px;
}

/* 与外层「运维诊断日报」页面「告警明细」的切换框/搜索框保持同一套视觉规范 */
.seg-tabs {
  display: inline-flex;
  flex-shrink: 0;
  padding: 4px;
  gap: 8px;
  border: 1px solid rgba(58, 104, 255, 0.08);
  border-radius: 999px;
  background: #F3F6FF;
  box-shadow: 0 4px 12px rgba(58, 104, 255, 0.08);
}

.seg-tab {
  min-width: 56px;
  padding: 6px 12px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: rgba(46, 46, 46, 0.65);
  font-family: 'PingFang SC', 'HarmonyOS Sans SC', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.seg-tab:hover {
  color: #2e2e2e;
}

.seg-tab:disabled {
  cursor: wait;
}

.seg-tab.active {
  color: #fff;
  background: #3A68FF;
  box-shadow: 0 6px 16px rgba(58, 104, 255, 0.35);
}

.search-input {
  flex: 0 0 240px;
  width: 240px;
}

.search-input :deep(.v-field) {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
}

.search-input :deep(.v-field__input) {
  min-height: 36px;
  font-size: 14px;
}
</style>
